export default __webpack_public_path__ + "b425069c3ecfecc5eb414276b83c2b3b.png";